import AccountTemplate from '../../templates/settings/ui/account';

export default function AccountPage() {
  return <AccountTemplate />;
}
